import React, { MouseEventHandler, PropsWithChildren, ReactNode } from 'react';

import { rem, Flex, useColorModeValue } from '@vimeo/bokeh';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';

import { BokehTooltip } from '../bokeh';
import { ESidebarAttach, TConfigProp } from './ResponsiveSidebar.types';

export interface IResponsiveSidebarPanelItemProps extends IBaseDomElementProps {
  attach: TConfigProp<ESidebarAttach>;
  label?: ReactNode;
  isMinified?: boolean;
  isActive?: boolean;
  isMobile?: boolean;
  icon?: ReactNode;
  onClick?: MouseEventHandler;
}
export function ResponsiveSidebarPanelItem({
  id,
  className,
  children = null,
  icon,
  label,
  isActive,
  isMinified,
  onClick,
}: PropsWithChildren<IResponsiveSidebarPanelItemProps>) {
  const background: string = useColorModeValue('slate.50', 'grayscale.700');
  const hoverBackground: string = useColorModeValue('slate.100', 'grayscale.500');

  const button = (
    <Flex
      id={id}
      className={className}
      direction={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      cursor={'pointer'}
      shrink={0}
      gap={rem(2)}
      height={isMinified ? rem(48) : rem(64)}
      width={isMinified ? rem(48) : rem(64)}
      minWidth={isMinified ? rem(48) : rem(64)}
      minHeight={isMinified ? rem(48) : rem(64)}
      padding={rem(4)}
      backgroundColor={isActive ? background : 'transparent'}
      borderRadius={rem(12)}
      textAlign={'center'}
      fontWeight={400}
      fontSize={rem(10)}
      lineHeight={rem(12)}
      whiteSpace={'nowrap'}
      _hover={{
        backgroundColor: hoverBackground,
      }}
      sx={{
        '& svg': {
          width: rem(20),
          height: rem(20),
        },
      }}
      onClick={onClick}
    >
      {icon}
      {isMinified ? null : children}
    </Flex>
  );

  // Wrap with tooltips for minified view where labels are hidden.
  return isMinified ? (
    <BokehTooltip placement={'right'} label={label} shouldWrapChildren={false}>
      {button}
    </BokehTooltip>
  ) : (
    button
  );
}
